export type SortDirection = 'asc' | 'desc'

export function sortTableList<T extends object>(
  items: T[],
  sortField: keyof T | null,
  sortDirection: SortDirection
): T[] {
  if (!sortField) return items

  return [...items].sort((a, b) => {
    const aValue = a[sortField]
    const bValue = b[sortField]

    if (aValue == null && bValue == null) return 0
    if (aValue == null) return 1
    if (bValue == null) return -1

    if (sortField === 'id') {
      const aStr = String(aValue).trim()
      const bStr = String(bValue).trim()
      const aNum = Number(aStr)
      const bNum = Number(bStr)

      if (
        !isNaN(aNum) &&
        !isNaN(bNum) &&
        aStr !== '' &&
        bStr !== '' &&
        isFinite(aNum) &&
        isFinite(bNum)
      ) {
        return sortDirection === 'asc' ? aNum - bNum : bNum - aNum
      }

      const comparison = aStr.localeCompare(bStr, undefined, {
        numeric: true,
        sensitivity: 'base',
      })
      return sortDirection === 'asc' ? comparison : -comparison
    }

    if (sortField === 'createdAt') {
      if (aValue && bValue) {
        const aDate = new Date(aValue as string).getTime()
        const bDate = new Date(bValue as string).getTime()
        if (!isNaN(aDate) && !isNaN(bDate)) {
          return sortDirection === 'asc' ? aDate - bDate : bDate - aDate
        }
      }
      const aStr = String(aValue || '')
      const bStr = String(bValue || '')
      const comparison = aStr.localeCompare(bStr)
      return sortDirection === 'asc' ? comparison : -comparison
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      const comparison = aValue.localeCompare(bValue)
      return sortDirection === 'asc' ? comparison : -comparison
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortDirection === 'asc' ? aValue - bValue : bValue - aValue
    }

    const aStr = String(aValue)
    const bStr = String(bValue)
    const comparison = aStr.localeCompare(bStr)
    return sortDirection === 'asc' ? comparison : -comparison
  })
}

export function filterTableList<T>(
  items: T[],
  searchTerm: string,
  matches: (item: T, term: string) => boolean
): T[] {
  if (!searchTerm) return items
  const term = searchTerm.toLowerCase()
  return items.filter(item => matches(item, term))
}
